import { createSliceContext } from "./CreateSliceContext";
import { IAmenity } from "../../@types/IAmenity";
import IBrand from "../../@types/IBrand";

interface PageIntroSliceProps {
  id?: any;
  parent_type?: string;
  field_title?: string;
  field_description?: string;
  field_link?: {
    url: string;
    title: string;
  };
  relationships?: {
    field_amenities?: Array<IAmenity>;
    brand?: Array<IBrand>;
  };
  children?: Array<any>;
  isbelowSearchParagraphs?: boolean;
}

const defaultPageIntroSliceValues: PageIntroSliceProps = {
  id: null,
  parent_type: "",
  field_title: "",
  field_description: "",
  field_link: undefined,
  relationships: {
    field_amenities: [],
    brand: [],
  },
  children: [],
  isbelowSearchParagraphs: false,
};

export const {
  Provider: PageIntroSliceProvider,
  useContext: usePageIntroSliceContext,
} = createSliceContext<PageIntroSliceProps>(
  "PageIntro",
  defaultPageIntroSliceValues
);
